import React from 'react'
import { FiInbox } from 'react-icons/fi'

function EmptyState({ icon: Icon = FiInbox, message = 'No data to show', action }) {
  return (
    <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-px-4 tw-py-10 tw-text-center'>
      <Icon aria-hidden='true' className='tw-h-14 tw-w-14 tw-text-disabled' strokeWidth={1.5} />
      <p className='tw-text-[16px] tw-text-inkSoft'>{message}</p>
      {action && (
        <button
          type='button'
          onClick={action.onClick}
          className='tw-inline-flex tw-h-9 tw-items-center tw-rounded-[10px] tw-border tw-border-line tw-bg-white tw-px-4 tw-text-[14px] tw-font-medium tw-text-ink hover:tw-bg-sand focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ember focus-visible:tw-ring-offset-2'
        >
          {action.label}
        </button>
      )}
    </div>
  )
}

export default EmptyState
